import React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  makeStyles,
  InputAdornment,
} from "@material-ui/core";
import StoreIcon from "@material-ui/icons/Store";
import RoomIcon from "@material-ui/icons/Room";
import MapIcon from "@material-ui/icons/Map";

const useStyles = makeStyles({
  root: {
    border: "2px #45cafc",
  },
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: `#303f9f !important`,
    },
  },
  notchedOutline: {
    borderWidth: "2px",
    borderColor: "#303f9f !important",
  },
});

const TextFieldStyled = ({
  value,
  name,
  error,
  label,
  onChange,
  adornment,
  edit,
}) => {
  const styles = useStyles();
  return (
    <TextField
      margin="dense"
      variant="outlined"
      fullWidth
      name={name}
      label={label}
      value={value}
      error={!value && error}
      onChange={onChange}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={
        edit && !error
          ? {
            classes: {
              root: styles.cssOutlinedInput,
              notchedOutline: styles.notchedOutline,
              focused: styles.focused,
            },
            readOnly: false,
            startAdornment: (
              <InputAdornment position="start">{adornment}</InputAdornment>
            ),
          }
          : {
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">{adornment}</InputAdornment>
            ),
          }
      }
    />
  );
};

const HrColor = () => {
  return (
    <hr
      color="#0099CC"
      style={{
        background:
          "linear-gradient(74deg, rgba(48,63,159,1) 21%, rgba(69,202,252,0.9) 100%)",
        height: 2,
        marginBottom: 24,
      }}
    />
  );
};

export default function GeneralDataForm({
  error,
  formData,
  setFormData,
  edit,
  communes,
}) {
  const updateData = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <HrColor />
        <h4>Información general</h4>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextFieldStyled
          value={formData.localName}
          name="localName"
          label="Nombre sucursal"
          error={error}
          edit={false}
          adornment={<StoreIcon />}
          onChange={updateData}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextFieldStyled
          value={formData.localAddress}
          name="localAddress"
          label="Dirección"
          error={error}
          edit={false}
          onChange={updateData}
          adornment={<RoomIcon />}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          margin="dense"
          variant="outlined"
          label="Comuna"
          name="localCommune"
          value={formData.localCommune}
          type="text"
          disabled
          select
          onChange={(e) => updateData(e)}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: !edit,
            startAdornment: (
              <InputAdornment>
                <MapIcon />
              </InputAdornment>
            ),
          }}
          error={!formData.localCommune && error}
        >
          <MenuItem value="">
            <em>Ninguna</em>
          </MenuItem>
          {communes.map((commune, idx) => (
            <MenuItem
              key={`op${idx}-${commune.code}`}
              value={commune.code}
            >
              {commune.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
}
